/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Language } from "src/utils/localization/languages/types";
import {
  AsCardFragment,
  AsCardForStaticQueryFragment
} from "types/graphql-types";

export type LocalizedStaticQueryResult<T> = Override<
  T,
  { card?: AsCardFragment }
>;

export function localizeStaticQuery<T>(
  items: (T & { card?: AsCardForStaticQueryFragment; i18nFullPaths? })[],
  language: Language
): LocalizedStaticQueryResult<T>[] {
  return items.map((item) => {
    const card = item.card;

    return {
      ...item,
      card: {
        ...card,
        title: { localized: (card?.title || {})[language.sanityCode] },
        description: {
          localized: (card?.description || {})[language.sanityCode]
        }
      },
      fullPath: item.i18nFullPaths[language.code]
    } as T;
  });
}
